import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const ButtondownFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Label htmlFor="connector-buttondown-secret">
        Buttondown API key {editor.connector ? "(leave blank to keep)" : ""}
      </Label>
      <Input
        id="connector-buttondown-secret"
        type="password"
        autoComplete="new-password"
        value={editor.secretValue}
        onChange={(e) =>
          setEditor((s) => ({ ...s, secretValue: e.target.value, clearSecret: false }))
        }
        placeholder="Stored encrypted"
        disabled={editor.clearSecret}
      />
      <p className="text-xs text-muted-foreground">
        Find your API key at{" "}
        <a
          href="https://buttondown.com/settings/programming"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Buttondown → Settings → API
        </a>
        . Used to create draft emails on dispatch — Excerptus never publishes for you.
      </p>
      {editor.connector && (
        <label className="flex items-center gap-2 text-xs text-muted-foreground">
          <input
            type="checkbox"
            checked={editor.clearSecret}
            onChange={(e) =>
              setEditor((s) => ({ ...s, clearSecret: e.target.checked, secretValue: "" }))
            }
          />
          Clear stored secret
        </label>
      )}
    </div>

    <p className="rounded-md border border-dashed border-border bg-muted/30 p-3 text-xs text-muted-foreground">
      Buttondown has no public image upload endpoint. Excerptus-hosted images in your draft will be
      stripped and listed as a publish checklist — re-upload them inside Buttondown before sending.
    </p>
  </div>
);
